import { LocationPageInterface } from "@swivl-mono/types";

import { slugifyFolder } from "../Worksheets/Reports/Reports.Helpers";
import { SearchEntry, SearchEntryScope, SearchResultCategory } from "./GlobalSearch.Types";

const PROPERTIES_V3_ROOT = "/properties-v3";

// Falls back to org scope when opened from outside Property Manager.
function resolvePreamble(page: LocationPageInterface): string {
  return page.preamble.startsWith(PROPERTIES_V3_ROOT) ? page.preamble : PROPERTIES_V3_ROOT;
}

// A value-match entry names the scope it was found in; a label-match entry has
// none and stays on whatever scope the user is currently viewing.
function preambleForEntry(scope: SearchEntryScope | undefined, page: LocationPageInterface): string {
  if (!scope) return resolvePreamble(page);
  if (scope.locationId) return `${PROPERTIES_V3_ROOT}/group/${scope.groupId}/location/${scope.locationId}`;
  if (scope.groupId) return `${PROPERTIES_V3_ROOT}/group/${scope.groupId}`;
  return PROPERTIES_V3_ROOT;
}

// Builds each result's href, preserving scope — only Location results change it.
export function buildResultHref(entry: SearchEntry, page: LocationPageInterface, currentSearch: string): string {
  switch (entry.category) {
    case SearchResultCategory.DETAILS_V3:
      return `${preambleForEntry(entry.scope, page)}/page/details-v3/${entry.subpage}`;
    case SearchResultCategory.POLICY:
      return `${preambleForEntry(entry.scope, page)}/page/policy-worksheets?policyKey=${entry.policyKey}`;
    case SearchResultCategory.REPORT:
      return `${preambleForEntry(entry.scope, page)}/page/reports/${slugifyFolder(entry.folder)}/${entry.dashboardId}`;
    case SearchResultCategory.LOCATION: {
      const suffix = page.path.split("/page")[1];
      const base = `/properties-v3/group/${entry.groupId}/location/${entry.locationId}/page${suffix || "/details-v3/facility-info"}`;
      return currentSearch ? `${base}${currentSearch}` : base;
    }
  }
}
